import React from "react";

export const PictureWall12 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={44} height={28} rx={1} fill="#F1F2F6" />

    <g fill="#8E97A9">
      <rect width={11} height={11} x={3.5} y={2} />
      <rect width={11} height={11} x={16.5} y={2} />
      <rect width={11} height={11} x={29.5} y={2} />
      <rect width={11} height={11} x={3.5} y={15} />
      <rect width={11} height={11} x={16.5} y={15} />
      <rect width={11} height={11} x={29.5} y={15} />
    </g>
  </g>
);
